import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { IQueryGetEntitiesFieldArgs } from './types';
import { useMemo } from 'react';
import {
  getFirstPaginatedNode,
  getPaginatedNodes,
  getPaginationTotalResults,
  toPagination,
} from './utils';

export const GET_ENTITIES_IP_ADDRESSES = graphql(`
  query getIpAddress($pagination: PaginationRequest, $uuid: String) {
    entities(filters: { submissionUuid: $uuid, submissionType: INSURED }) {
      edges {
        cursor
        node {
          ipAddresses(pagination: $pagination) {
            pageInfo {
              totalResults
              pageNumber
              pageSize
              hasNextPage
              hasPreviousPage
            }
            edges {
              cursor
              node {
                uuid
                ipv4Address
                ipv4AddressDecimal
                ipv6Address
                ipv6AddressDecimal
              }
            }
          }
        }
      }
    }
  }
`);

export function useGetEntitiesIpAddressesQuery({
  submissionUuid,
  pageNumber,
  pageSize,
}: IQueryGetEntitiesFieldArgs) {
  const { loading, error, data } = useQuery(GET_ENTITIES_IP_ADDRESSES, {
    variables: {
      uuid: submissionUuid,
      pagination: toPagination(pageNumber, pageSize),
    },
  });

  const { ipAddresses, totalIpAddresses } = useMemo(() => {
    if (loading) {
      return {
        ipAddressesData: [],
        totalIpAddresses: 0,
      };
    }
    const entity = getFirstPaginatedNode(data?.entities);
    return {
      ipAddresses: getPaginatedNodes(entity?.ipAddresses),
      totalIpAddresses: getPaginationTotalResults(entity?.ipAddresses) ?? 0,
    };
  }, [data, loading]);

  return {
    loading,
    error,
    data,
    ipAddresses,
    totalIpAddresses,
  };
}
